import { render, staticRenderFns } from "./Me.vue?vue&type=template&id=ce07d42c&scoped=true&"
import script from "./Me.vue?vue&type=script&lang=js&"
export * from "./Me.vue?vue&type=script&lang=js&"
import style0 from "./Me.vue?vue&type=style&index=0&id=ce07d42c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce07d42c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
installComponents(component, {VAvatar})
